import Lottie from 'lottie-react';

import json from '../jsons/thinking-skeptic-person-avatar-in-reveal.json';

const ThinkingAnimated = props => {
  return <Lottie loop={false} animationData={json} {...props} />;
};

export default ThinkingAnimated;
